import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { PedidoItemDescontoMaximoExcedidoTableViewComponent } from '../../../item/components/desconto-maximo-excedido-table-view';

@Component({
    selector: 'sgt-pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos',
    templateUrl: './pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos.component.html',
    styleUrls: ['./pedido-nao-liberado-card-info-descontos-maximos-itens-excedidos.component.less']
})
export class PedidoNaoLiberadoCardInfoDescontosMaximosItensExcedidosComponent implements OnChanges {
    @Input() idPedido: number;
    @Input() tipoVenda: number;
    @Input() dataNaoLiberado: Date;
    @ViewChild('tableView') tableView: PedidoItemDescontoMaximoExcedidoTableViewComponent;

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'idPedido') {
                setTimeout(() => {
                    this.tableView?.search(this.idPedido);
                }, 0);
            }
        }
    }
}
